import {
  BOOKS_CHANNEL_CUSTOM_TYPE,
  COMPANY_GROUP_CUSTOM_TYPE,
} from "constants/channelType";
import { useChatFilterContext } from "contexts/ChatFilterContext";
import { ChannelFilters } from "stream-chat";
import { DefaultStreamChatGenerics } from "stream-chat-react";

export const useStreamFilterQuery =
  (): ChannelFilters<DefaultStreamChatGenerics> => {
    const { filters: values } = useChatFilterContext();

    const customTypeFilterValues = [];

    if (values.CHANNEL.some((channel) => channel === "GENERAL_HELP")) {
      customTypeFilterValues.push(COMPANY_GROUP_CUSTOM_TYPE);
    }
    if (values.CHANNEL.some((channel) => channel === "BOOKS")) {
      customTypeFilterValues.push(BOOKS_CHANNEL_CUSTOM_TYPE);
    }

    let typeFilter = {};

    if (values.CHANNEL.length > 0 && customTypeFilterValues.length > 0) {
      // Both filters have values, use $or
      typeFilter = {
        $or: [
          {
            channel_type: {
              $in: values.CHANNEL,
            },
          },
          {
            custom_type: {
              $in: customTypeFilterValues,
            },
          },
        ],
      };
    } else if (values.CHANNEL.length > 0) {
      // Only channel type has values
      typeFilter = {
        channel_type: {
          $in: values.CHANNEL,
        },
      };
    }

    return {
      ...typeFilter,

      ...(values.COMPANY.length > 0 && {
        group_uuid: {
          $in: values.COMPANY,
        },
      }),

      ...(values.AGENT.length > 0 && {
        assigned_agent: {
          $in: values.AGENT,
        },
      }),

      ...(values.STATUS.length > 0 && {
        task_status_id: {
          $in: values.STATUS,
        },
      }),

      ...(values.START_DATE &&
        values.END_DATE && {
          $and: [
            {
              last_message_at: {
                $gte: new Date(values.START_DATE).toISOString(),
              },
            },

            {
              last_message_at: {
                $lte: new Date(values.END_DATE).toISOString(),
              },
            },
          ],
        }),
    };
  };
